/**
 * Should the website suggest the Android app? Pure, so it can be tested.
 *
 * Android is read from the user agent. That is reliable enough for a
 * suggestion — a few phones hide it (desktop-site mode), and those people just
 * don't get a banner; the More tab still has the link.
 */

export const DISMISS_DAYS = 30
export const APK_URL = '/downloads/macro-latest.apk'

export function isAndroidUA(ua: string): boolean {
  return /Android/i.test(ua)
}

export function shouldShowBanner(opts: {
  ua: string; native: boolean; dismissedAt: number | null; now: number; hasApp?: boolean
}): boolean {
  // hasApp: this account already uses the app on an Android phone.
  if (opts.native || opts.hasApp || !isAndroidUA(opts.ua)) return false
  if (opts.dismissedAt === null) return true
  return opts.now - opts.dismissedAt > DISMISS_DAYS * 86_400_000
}

export type MoreEntry = 'hidden' | 'install' | 'link'

/** The More tab's entry: nothing inside the app, the install sheet on an
 *  Android browser, a plain link elsewhere. */
export function moreEntry(ua: string, native: boolean): MoreEntry {
  if (native) return 'hidden'
  return isAndroidUA(ua) ? 'install' : 'link'
}
